export default "__VITE_ASSET__f2959e6f__"